import React, { useState } from 'react';
import _ from 'lodash';
import { connectDynamic } from '../dynamicComponent';
import { Divider, Form, Button, Icon } from 'semantic-ui-react';
import { ContentDispatch } from 'framework';
import SpanText from 'app-ui-componentlibrary/dist/go/components/common/form/SpanText';
import { displayObjectErrors } from 'common/utils';
import {DeleteModal} from 'app-ui-componentlibrary';
import { ALWAYS_DIRTY_MAP} from 'app-ui-componentlibrary/dist/common/constants';


export const ContinuousFormModule = (props) => {
  const { contents, entityDataPath, editMode, validationErrors, validationDirtyMap, entityType, validationId } = props;
  const defaultModalConfig = {
    opened : false,
    selectedIndex: undefined
  }
  const [count, setCount] = useState(props.data && props.data.length ? props.data.length : 1);
  const [modalConfig, setModalConfig] = useState(defaultModalConfig);
  const deleteRecordItem = (index) => {
    props.saveEntityData(`${entityDataPath}`, entityType, [...props.data.slice(0, index), ...props.data.slice(index + 1)] ); setCount(count - 1); hideDeleteModal();
  };

  const deleteAction = () => { deleteRecordItem(modalConfig.selectedIndex); };
  const hideDeleteModal = () => { setModalConfig(defaultModalConfig); };  
  const showDeleteModal = (index) => { if (count > 1) setModalConfig({ opened : true, selectedIndex: index }); };

  const getError = (fieldPath) => {
    return displayObjectErrors(validationErrors, ALWAYS_DIRTY_MAP, fieldPath);
  };

  const isDirty = (index, fieldName) =>
    _.get(validationDirtyMap, 'dirtyPage', false) ||
    _.get(validationDirtyMap, ['dirty', index, fieldName], false);

  const canDelete = count > 1;
  let editConfig = props.editConfig?props.editConfig:{
    activity: "record",
    deleteModal: {
      displayText: "Are you sure you want to delete this record",
      displayTitle: "Remove Section"
    }
  }
  return (
    <Form>
      { editMode && (
        <DeleteModal
          displayTitle={editConfig.deleteModal.displayTitle}
          displayText={editConfig.deleteModal.displayText}
          open={modalConfig.opened}
          cancelAction={hideDeleteModal}
          deleteAction={deleteAction}
        />
      )}
      
      {_.range(count).map((curr) => (
        <>
          <Divider />
          { editMode && curr !=0 && (
            <div align='right'>
              <a
                  id={`delete-item-${curr}`}
                  href="#"
                  onClick={() => showDeleteModal(curr)}
                  className={"color--red"}
                  style={{color: '#CD2026', 'font-size': '12px'}}
                  title={`Open pop-up form to confirm deleting ${editConfig.activity}`}
                >
                  <Icon link name="close" color="red" />
                  Delete this {editConfig.activity}
                </a>
            </div>
          )}
          {contents.map((content) => {
            // This expects entityDataPath for the contents to JUST be the field name and not the full path
            const fullEntityDataPath = `${entityDataPath}[${curr}].${content.entityDataPath}`;

            const subValidationId = `${content.validationId}`;
            //error validation id
            const error = getError(`[0].error.[${curr}].${subValidationId}`);
            const fieldIsDirty = isDirty(curr, subValidationId);
            const completeValidationId = validationId + '.' + curr + '.' + subValidationId;
            let indexedContent = {...content, currentIndex:curr};
            if(indexedContent.id !== undefined){
              indexedContent.id = indexedContent.id + "#" + curr;
            }
            if(editMode){
              indexedContent.validationId = completeValidationId;
            }
            
            return (
              <React.Fragment>
                {
                  editMode &&  (
                      <SpanText
                        name={`${fullEntityDataPath}`}
                        displayError={fieldIsDirty && error.displayError}
                        errorMessages={error.errorMessages}
                      />
                  )
                }
                <ContentDispatch key={content.type + '#' + curr}
                    config={indexedContent}
                    entityDataPath={fullEntityDataPath}
                />
              </React.Fragment>

            );
          })}
          {curr === count - 1 && editMode && (
            <>
              <Button
                primary
                title={'Add new ' + editConfig.activity}
                onClick={() => {
                  setCount(count + 1);
                }}
              >
                Add {editConfig.activity}
              </Button>
            </>
          )}
        </>
      ))}
    </Form>
  );
};

export default connectDynamic(ContinuousFormModule);
